module.exports = __webpack_public_path__ + "img/asteroid2.5be6bb99.jpg";